import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { memo } from "react";
import { SharePrivateContentPermissionToggle } from "~/components/SharePrivateContentModal/shared/SharePrivateContentPermissionToggle";
import { SharePermissionSection } from "~/components/SharePrivateContentModal/SharePrivateContentSettings/SharePermissionSection";
export const ShareCustomFieldsPermissions = /*#__PURE__*/ memo((param)=>{
    let { onPermissionUpdated, shortIdInfo, isLoading, canViewCustomFields, canEditCustomFields } = param;
    return /*#__PURE__*/ _jsxs(SharePermissionSection, {
        title: "Custom fields",
        children: [
            /*#__PURE__*/ _jsx(SharePrivateContentPermissionToggle, {
                label: "Show custom fields",
                id: "customField.canView",
                isLoading: isLoading,
                checked: shortIdInfo.permissions.customField.canView,
                onCheckedChange: (checked)=>onPermissionUpdated({
                        customField: {
                            canView: checked,
                            canManageApplications: checked ? shortIdInfo.permissions.customField.canManageApplications : false
                        }
                    }),
                disabled: !canViewCustomFields || shortIdInfo.permissions.customField.canManageApplications && !canEditCustomFields
            }),
            /*#__PURE__*/ _jsx(SharePrivateContentPermissionToggle, {
                label: "Allow editing custom fields",
                id: "customField.canManageApplications",
                isLoading: isLoading,
                checked: shortIdInfo.permissions.customField.canManageApplications,
                onCheckedChange: (checked)=>onPermissionUpdated({
                        customField: {
                            canManageApplications: checked
                        }
                    }),
                disabled: !canEditCustomFields || !shortIdInfo.permissions.customField.canView
            })
        ]
    });
});
ShareCustomFieldsPermissions.displayName = "ShareCustomFieldsPermissions";
